module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cbkqm"))).then(() => module.bundle.root('ikE14'));